import React from "react";
import { useTranslation } from "react-i18next";

const ComingSoon = () => {
  const { t } = useTranslation();
  const label = t("Common.UnderConstruction", { defaultValue: "Under Construction" });
  return (
    <section
      aria-label={label}
      style={{
        width: "100%",
        minHeight: "calc(100vh - 110px)",
        background: "transparent",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
        <span
          role="img"
          aria-label={label}
          title={label}
          style={{ fontSize: "clamp(64px, 12vw, 140px)", lineHeight: 1 }}
        >
          🚧
        </span>
        <div
          style={{
            fontSize: "clamp(18px, 3.2vw, 28px)",
            fontWeight: 800,
            letterSpacing: 0.5,
            color: "#444",
            textAlign: "center",
          }}
        >
          {label}
        </div>
      </div>
    </section>
  );
};

export default ComingSoon;
